import APSlidingRightPanelContainer from "./APSlidingRightPanelContainer";

export {
    APSlidingRightPanelContainer
};

export default APSlidingRightPanelContainer;
